(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["czr-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('czr-carrossel')) {
    customElements.define(
      'czr-carrossel',
      class extends HTMLElement {
        connectedCallback() {
          this.trilho = this.querySelector('[data-trilho]');
          this.pontos = [...this.querySelectorAll('[data-ponto]')];
          this.atual = 0;
          this.pontos.forEach((p) => p.addEventListener('click', () => this.ir(Number(p.dataset.ponto), true)));
          this.trilho.addEventListener('scroll', () => this.sincronizar(), { passive: true });
          const parado = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.intervalo = Number(this.dataset.intervalo) || 5000;
          if (!parado && this.pontos.length > 1) {
            this.addEventListener('mouseenter', () => this.parar());
            this.addEventListener('mouseleave', () => this.tocar());
            this.addEventListener('focusin', () => this.parar());
            this.addEventListener('focusout', () => this.tocar());
            this.addEventListener('touchstart', () => this.parar(), { passive: true });
            this.tocar();
          }
        }
        disconnectedCallback() {
          this.parar();
        }
        tocar() {
          this.parar();
          this.relogio = setInterval(() => this.ir((this.atual + 1) % this.pontos.length), this.intervalo);
        }
        parar() {
          clearInterval(this.relogio);
        }
        ir(i, manual) {
          const largura = this.trilho.clientWidth;
          this.trilho.scrollTo({ left: largura * i, behavior: 'smooth' });
          this.marcar(i);
          if (manual) this.parar();
        }
        sincronizar() {
          const i = Math.round(this.trilho.scrollLeft / Math.max(1, this.trilho.clientWidth));
          if (i !== this.atual) this.marcar(i);
        }
        marcar(i) {
          this.atual = i;
          this.pontos.forEach((p, n) => p.toggleAttribute('aria-current', n === i));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
